const DASHBOARD = "/dashboard";
const LOGIN = `/login`;
const AUTH_ROUTES = [LOGIN];

const APP_SETTING_ACCESS = {
  LIST: `/app-setting/access`,
  ADD: `/app-setting/access/add`,
  UPDATE: `/app-setting/access/update`,
};

const APP_SETTING_CLIENT_APP_VERSION = {
  LIST: `/app-setting/client-app-version`,
  ADD: `/app-setting/client-app-version/add`,
  UPDATE: `/app-setting/client-app-version/update`,
};

const APP_SETTING_ENTITY = {
  LIST: `/app-setting/entity`,
  ADD: `/app-setting/entity/add`,
  UPDATE: `/app-setting/entity/update`,
};

const APP_SETTING_FEATURE = {
  LIST: `/app-setting/feature`,
  ADD: `/app-setting/feature/add`,
  UPDATE: `/app-setting/feature/update`,
};

const APP_SETTING_PARAMETER = {
  LIST: `/app-setting/parameter`,
  ADD: `/app-setting/parameter/add`,
  UPDATE: `/app-setting/parameter/update`,
};

const APP_SETTING_PARAMETER_ITEM = {
  LIST: `/app-setting/parameter-item`,
  ADD: `/app-setting/parameter-item/add`,
  UPDATE: `/app-setting/parameter-item/update`,
};

const APP_SETTING_ROLE = {
  LIST: `/app-setting/role`,
  ADD: `/app-setting/role/add`,
  UPDATE: `/app-setting/role/update`,
};

const APP_SETTING_TASK_SCHEDULE = {
  LIST: `/app-setting/task-schedule`,
  ADD: `/app-setting/task-schedule/add`,
  UPDATE: `/app-setting/task-schedule/update`,
};

const APP_SETTING_USER = {
  LIST: `/app-setting/user`,
  ADD: `/app-setting/user/add`,
  UPDATE: `/app-setting/user/update`,
};

const MASTER_DATA_BATTERY = {
  LIST: `/master-data/battery`,
  ADD: `/master-data/battery/add`,
  UPDATE: `/master-data/battery/update`,
};

const MASTER_DATA_CABINET = {
  LIST: `/master-data/cabinet`,
  ADD: `/master-data/cabinet/add`,
  UPDATE: `/master-data/cabinet/update`,
  DETAIL: `/master-data/cabinet/detail`,
};

const MASTER_DATA_POOL = {
  LIST: `/master-data/pool`,
  ADD: `/master-data/pool/add`,
  UPDATE: `/master-data/pool/update`,
  DETAIL: `/master-data/pool/detail`,
};

const MASTER_DATA_CABINET_DETAIL = {
  LIST: `/master-data/cabinet-detail`,
  ADD: `/master-data/cabinet-detail/add`,
  UPDATE: `/master-data/cabinet-detail/update`,
};

const MASTER_DATA_CABINET_DETAIL_LOG = {
  LIST: `/master-data/cabinet-detail-log`,
  ADD: `/master-data/cabinet-detail-log/add`,
  UPDATE: `/master-data/cabinet-detail-log/update`,
};

const MASTER_DATA_CITY = {
  LIST: `/master-data/city`,
  ADD: `/master-data/city/add`,
  UPDATE: `/master-data/city/update`,
};

const MASTER_DATA_CUSTOMER = {
  LIST: `/master-data/customer`,
  ADD: `/master-data/customer/add`,
  UPDATE: `/master-data/customer/update`,
};

const MASTER_DATA_IOT_DEVICE = {
  LIST: `/master-data/iot-device`,
  ADD: `/master-data/iot-device/add`,
  UPDATE: `/master-data/iot-device/update`,
  HISTORY_LOCATION: (id: number | string): string =>
    `/master-data/iot-device/history-location/${id}`,
};

const MASTER_DATA_MOTORCYCLE = {
  LIST: `/master-data/motorcycle`,
  ADD: `/master-data/motorcycle/add`,
  UPDATE: `/master-data/motorcycle/update`,
  DETAIL: `/master-data/motorcycle/detail`,
};

const MASTER_DATA_MOTORCYCLE_BATTERY = {
  LIST: `/master-data/motorcycle-battery`,
  ADD: `/master-data/motorcycle-battery/add`,
  UPDATE: `/master-data/motorcycle-battery/update`,
};

const MASTER_DATA_MOTORCYCLE_BATTERY_LOG = {
  LIST: `/master-data/motorcycle-battery-log`,
  ADD: `/master-data/motorcycle-battery-log/add`,
  UPDATE: `/master-data/motorcycle-battery-log/update`,
};

const MASTER_DATA_MOTORCYCLE_OWNERSHIP = {
  LIST: `/master-data/motorcycle-ownership`,
  ADD: `/master-data/motorcycle-ownership/add`,
  UPDATE: `/master-data/motorcycle-ownership/update`,
};

const MASTER_DATA_MOTORCYCLE_REGISTERED = {
  LIST: `/master-data/motorcycle-registered`,
  ADD: `/master-data/motorcycle-registered/add`,
  UPDATE: `/master-data/motorcycle-registered/update`,
};

const MASTER_DATA_PRODUCT = {
  LIST: `/master-data/product`,
  ADD: `/master-data/product/add`,
  UPDATE: `/master-data/product/update`,
};

const MASTER_DATA_PRODUCT_CATEGORY = {
  LIST: `/master-data/product-category`,
  ADD: `/master-data/product-category/add`,
  UPDATE: `/master-data/product-category/update`,
};

const MASTER_DATA_PROVINCE = {
  LIST: `/master-data/province`,
  ADD: `/master-data/province/add`,
  UPDATE: `/master-data/province/update`,
};

const MASTER_DATA_SIM_CARD = {
  LIST: `/master-data/sim-card`,
  ADD: `/master-data/sim-card/add`,
  UPDATE: `/master-data/sim-card/update`,
};

const MASTER_DATA_STAFF = {
  LIST: `/master-data/staff`,
  ADD: `/master-data/staff/add`,
  UPDATE: `/master-data/staff/update`,
};

const TRANSACTION_DATA_TRANSACTION_BATTERY = {
  LIST: `/transaction-data/transaction-battery`,
  ADD: `/transaction-data/transaction-battery/add`,
  UPDATE: `/transaction-data/transaction-battery/update`,
};

const TRANSACTION_DATA_TRANSACTION_HEADER = {
  LIST: `/transaction-data/transaction-header`,
  ADD: `/transaction-data/transaction-header/add`,
  UPDATE: `/transaction-data/transaction-header/update`,
};

const TRANSACTION_DATA_TRANSACTION_ITEM = {
  LIST: `/transaction-data/transaction-item`,
  ADD: `/transaction-data/transaction-item/add`,
  UPDATE: `/transaction-data/transaction-item/update`,
};

const TRANSACTION_DATA_TRANSACTION_RENT_MOTORCYCLE = {
  LIST: `/transaction-data/transaction-rent-motorcycle`,
  ADD: `/transaction-data/transaction-rent-motorcycle/add`,
  UPDATE: `/transaction-data/transaction-rent-motorcycle/update`,
};

const TRANSACTION_DATA_TRANSACTION_RENT_PRODUCT = {
  LIST: `/transaction-data/transaction-rent-product`,
  ADD: `/transaction-data/transaction-rent-product/add`,
  UPDATE: `/transaction-data/transaction-rent-product/update`,
};

const TRANSACTION_DATA_TRANSACTION_RENT_PACKAGE = {
  LIST: `/transaction-data/package`,
  ADD: `/transaction-data/transaction-rent-package/add`,
  UPDATE: `/transaction-data/transaction-rent-package/update`,
  DETAIL: `/transaction-data/package/detail`,
};

const TRANSACTION_DATA_TRANSACTION_STATUS = {
  LIST: `/transaction-data/transaction-status`,
  ADD: `/transaction-data/transaction-status/add`,
  UPDATE: `/transaction-data/transaction-status/update`,
};

const TRANSACTION_DATA_TRANSACTION_TOPUP = {
  LIST: `/transaction-data/transaction-topup`,
  ADD: `/transaction-data/transaction-topup/add`,
  UPDATE: `/transaction-data/transaction-topup/update`,
};

const TRANSACTION_DATA_TRANSACTION_TYPE = {
  LIST: `/transaction-data/transaction-type`,
  ADD: `/transaction-data/transaction-type/add`,
  UPDATE: `/transaction-data/transaction-type/update`,
};

const TRANSACTION_DATA_TRANSACTION_WALLET = {
  LIST: `/transaction-data/transaction-wallet`,
  ADD: `/transaction-data/transaction-wallet/add`,
  UPDATE: `/transaction-data/transaction-wallet/update`,
};

const TRANSACTION_DATA_CHARGING_AND_SWAPPING = {
  LIST: `/transaction-data/charging-and-swapping`,
  ADD: `/transaction-data/charging-and-swapping/add`,
  UPDATE: `/transaction-data/charging-and-swapping/update`,
  DETAIL: `/transaction-data/charging-and-swapping/detail`,
};

const PRODUCT_DATA_PRODUCT = {
  LIST: `/product/data-product`,
  ADD: `/product/data-product/add`,
  UPDATE: `/product/data-product/update`,
  DETAIL: `/product/data-product/detail`,
};

const PRODUCT_DATA_GROUP_PRODUCT = {
  LIST: `/product/data-group-product`,
  ADD: `/product/data-group-product/add`,
  UPDATE: `/product/data-group-product/update`,
  DETAIL: `/product/data-group-product/detail`,
  ADD_PRODUCT_DATA: (id: string | number) =>
    `/product/data-group-product/detail/${id}/add-product-data`,
  PRODUCT_DATA_DETAIL: (groupId: string | number, productId: string | number) =>
    `/product/data-group-product/detail/${groupId}/product-detail/${productId}`,
  PRODUCT_DATA_UPDATE: (groupId: string | number, productId: string | number) =>
    `/product/data-group-product/detail/${groupId}/product-update/${productId}`,
};

const PRODUCT_TERM_AND_CONDITION = {
  LIST: `/product/tnc`,
  ADD: `/product/tnc/add`,
  UPDATE: `/product/tnc/update`,
  DETAIL: `/product/tnc/detail`,
};

const DRIVER_DRIVERS = {
  LIST: `/driver/drivers`,
  ADD: `/driver/drivers/add`,
  UPDATE: `/driver/drivers/update`,
  DETAIL: `/driver/drivers/detail`,
};

const REVENUE_SHARING = {
  LIST: "/report/revenue-sharing",
};

const PIC_DRIVER = {
  LIST: "/pic-driver",
  ADD: `/pic-driver/add`,
  UPDATE: `/pic-driver/update`,
};

export {
  DASHBOARD,
  LOGIN,
  AUTH_ROUTES,
  APP_SETTING_ACCESS,
  APP_SETTING_CLIENT_APP_VERSION,
  APP_SETTING_ENTITY,
  APP_SETTING_FEATURE,
  APP_SETTING_PARAMETER,
  APP_SETTING_PARAMETER_ITEM,
  APP_SETTING_ROLE,
  APP_SETTING_TASK_SCHEDULE,
  APP_SETTING_USER,
  MASTER_DATA_BATTERY,
  MASTER_DATA_CABINET,
  MASTER_DATA_CABINET_DETAIL,
  MASTER_DATA_CABINET_DETAIL_LOG,
  MASTER_DATA_CITY,
  MASTER_DATA_CUSTOMER,
  MASTER_DATA_IOT_DEVICE,
  MASTER_DATA_MOTORCYCLE,
  MASTER_DATA_MOTORCYCLE_BATTERY,
  MASTER_DATA_MOTORCYCLE_BATTERY_LOG,
  MASTER_DATA_MOTORCYCLE_OWNERSHIP,
  MASTER_DATA_MOTORCYCLE_REGISTERED,
  MASTER_DATA_PRODUCT,
  MASTER_DATA_PRODUCT_CATEGORY,
  MASTER_DATA_PROVINCE,
  MASTER_DATA_SIM_CARD,
  MASTER_DATA_STAFF,
  TRANSACTION_DATA_TRANSACTION_BATTERY,
  TRANSACTION_DATA_TRANSACTION_HEADER,
  TRANSACTION_DATA_TRANSACTION_ITEM,
  TRANSACTION_DATA_TRANSACTION_RENT_MOTORCYCLE,
  TRANSACTION_DATA_TRANSACTION_RENT_PRODUCT,
  TRANSACTION_DATA_TRANSACTION_RENT_PACKAGE,
  TRANSACTION_DATA_TRANSACTION_STATUS,
  TRANSACTION_DATA_TRANSACTION_TOPUP,
  TRANSACTION_DATA_TRANSACTION_TYPE,
  TRANSACTION_DATA_TRANSACTION_WALLET,
  TRANSACTION_DATA_CHARGING_AND_SWAPPING,
  PRODUCT_DATA_PRODUCT,
  PRODUCT_DATA_GROUP_PRODUCT,
  PRODUCT_TERM_AND_CONDITION,
  DRIVER_DRIVERS,
  MASTER_DATA_POOL,
  REVENUE_SHARING,
  PIC_DRIVER,
};
